__turbopack_context__.v({
  "altGrid": "ProductGrid-module-scss-module___ZaCpq__altGrid",
  "body": "ProductGrid-module-scss-module___ZaCpq__body",
  "content": "ProductGrid-module-scss-module___ZaCpq__content",
  "debugPosition": "ProductGrid-module-scss-module___ZaCpq__debugPosition",
  "grid2": "ProductGrid-module-scss-module___ZaCpq__grid2",
  "grid3": "ProductGrid-module-scss-module___ZaCpq__grid3",
  "imageContainer": "ProductGrid-module-scss-module___ZaCpq__imageContainer",
  "imageGrid": "ProductGrid-module-scss-module___ZaCpq__imageGrid",
  "longGrid": "ProductGrid-module-scss-module___ZaCpq__longGrid",
  "productGrid": "ProductGrid-module-scss-module___ZaCpq__productGrid",
  "ratings": "ProductGrid-module-scss-module___ZaCpq__ratings",
  "textLarge": "ProductGrid-module-scss-module___ZaCpq__textLarge",
  "textSmall": "ProductGrid-module-scss-module___ZaCpq__textSmall",
});
